import React from 'react';
import { Col, Row, Tooltip, OverlayTrigger } from 'react-bootstrap';

import boardOfDirectors1 from '../../../assets/images/CSIO_BoardGrouping_1.png';
import boardOfDirectors2 from '../../../assets/images/CSIO_BoardGrouping_2.png';

const BoardOfDirectors = ({ width, isMobile }) => {

  return (
    <Col>
      <Row>
        <Col>
          <h3
            id="board-of-directors"
            tabIndex="-1"
            style={{
              textAlign: 'center',
            }}
          >
            BOARD of directors
          </h3>
          <p>
            The Board of Directors generously offer their time and knowledge to provide direction to CSIO. We offer our sincere thanks to these industry leaders and executives from across the industry.          </p>
        </Col>
      </Row>
      {/* {width > 992 &&  */}
      <Row>
        <Col xs={12} md={6} style={{
          paddingLeft: isMobile ? 0 : 24,
          paddingRight: 0,
          paddingTop: 1,
        }}>
          <Row>
            <TooltipTarget left="12.1%" name="Cam Loeppky" title="CSIO Chairman; The Wawanesa Mutual Insurance Company, Senior Vice President & Chief Information Officer" number="1" />
            <TooltipTarget left="24.25%" name="Steve Earle" title="Bauld Insurance, President" number="2" />
            <TooltipTarget left="38.50%" name="Mathieu Brunet" title="MP2B Assurance Inc., Vice President Sales & Specialised Insurance" number="3" />
            <TooltipTarget left="59.65%" name="Robyn Young" title="Excel & Y, Lundgren & Young Insurance, President & Chief Executive Officer" number="4" />
            <TooltipTarget left="74.35%" name="Luc Tanguay" title="Intact Insurance, Vice President - Operations & Planning - Commercial Lines" number="5" />
            <TooltipTarget left="87.5%" name="John Elliott" title="RSA Canada, Senior Vice President & Chief Information Officer" number="6" />
            <img
              src={boardOfDirectors1}
              style={{
                width: '100%',
                height: '100%',
                marginTop: 20
              }}
              aria-label="CSIO Board of Directors"
            />
          </Row>

        </Col>
        <Col xs={12} md={6} style={{
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: 20
        }}>
          <Row>
            <TooltipTarget left="6.75%" name="Michael Loeters" title="PROLINK, Senior Vice President, Commercial Insurance & Risk Management" number="7" />
            <TooltipTarget left="18.75%" name="Peter Braid" title="Guest Member; Insurance Brokers Association of Canada, Chief Executive Officer" number="8" />
            <TooltipTarget left="33.25%" name="Elaine Basque" title="Aviva Canada, Vice President, Platforms" number="9" />
            <TooltipTarget left="51%" name="Christopher Harness" title="Northbridge Financial Corporation, Chief Information Officer" number="10" />
            <TooltipTarget left="64.35%" name="Sheldon Wasylenko" title="CSIO Vice-Chair; Rayner Agencies Ltd., General Manager" number="11" />
            <TooltipTarget left="76.5%" name="Michael Lin" title="Travelers Canada, Chief Information Officer" number="12" />
            <TooltipTarget left="89.5%" name="Catherine Smola" title="CSIO President & Chief Executive Officer" number="13" />
            <img
              src={boardOfDirectors2}
              style={{
                width: '100%',
                height: '100%',
                marginTop: 20
              }}
              aria-label="CSIO Board of Directors"
            />
          </Row>

        </Col>
      </Row>
      {/* } */}
      <Row>
        <Col>
          <ol className={width > 992 ? 'boardOfDirectorsLg boardOfDirectors' : width > 768 ? 'boardOfDirectorsMd boardOfDirectors' : 'boardOfDirectorsSm boardOfDirectors'} >
            <li>
              Cam Loeppky<span className="boardOfDirectorsDesc"> CSIO Chairman; The Wawanesa Mutual Insurance Company, Senior Vice President & Chief Information Officer</span>
            </li>
            <li>
              Steve Earle<span className="boardOfDirectorsDesc"> Bauld Insurance, President</span>
            </li>
            <li>
              Mathieu Brunet<span className="boardOfDirectorsDesc"> MP2B Assurance Inc., Vice President Sales & Specialised Insurance</span>
            </li>
            <li>
              Robyn Young<span className="boardOfDirectorsDesc"> Excel & Y, Lundgren & Young Insurance, President & Chief Executive Officer</span>
            </li>
            <li>
              Luc Tanguay<span className="boardOfDirectorsDesc"> Intact Insurance, Vice President - Operations & Planning - Commercial Lines</span>
            </li>
            <li>
              John Elliott<span className="boardOfDirectorsDesc"> RSA Canada, Senior Vice President & Chief Information Officer</span>
            </li>
            <li>
              Michael Loeters<span className="boardOfDirectorsDesc"> PROLINK, Senior Vice President, Commercial Insurance & Risk Management</span>
            </li>
            <li>
              Peter Braid<span className="boardOfDirectorsDesc"> Guest Member; Insurance Brokers Association of Canada, Chief Executive Officer</span>
            </li>
            <li>
              Elaine Basque<span className="boardOfDirectorsDesc"> Aviva Canada, Vice President, Platforms</span>
            </li>
            <li>
              Christopher Harness<span className="boardOfDirectorsDesc"> Northbridge Financial Corporation, Chief Information Officer</span>
            </li>
            <li>
              Sheldon Wasylenko<span className="boardOfDirectorsDesc"> CSIO Vice-Chair; Rayner Agencies Ltd., General Manager</span>
            </li>
            <li>
              Michael Lin<span className="boardOfDirectorsDesc"> Travelers Canada, Chief Information Officer</span>
            </li>
            <li>
              Catherine Smola<span className="boardOfDirectorsDesc"> CSIO President & Chief Executive Officer</span>
            </li>
          </ol>
        </Col>
      </Row>
    </Col >
  )
}

export default BoardOfDirectors;

const TooltipTarget = ({ left, name, title, number }) => (
  <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={
      <Tooltip id="button-tooltip" style={{ marginBottom: 2}}>
        <div style={{ backgroundColor: 'white' }}>
          <span className="boardOfDirectorsLg" style={{
            color: '#004761',
            letterSpacing: .7,
            fontSize: 14,
            fontFamily: 'Raleway Regular',
            fontWeight: 'bold',
            width: '100%'
          }}
          >{`${name}`}</span><span className="boardOfDirectorsDesc">{` ${title}`}</span>
        </div>

      </Tooltip>
    }
  >
    <div style={{
      marginTop: 0,
      width: 34,
      height: 34,
      borderRadius: 17,
      border: '1px solid #004761',
      zIndex: 3,
      position: 'absolute',
      left,
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'Montserrat Medium',
      color: '#004761',
      paddingTop: 1,
      // paddingRight: 1
    }}>
      {number}
    </div>
  </OverlayTrigger>
);
